module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only ",
    attrs: {
      "xs12": "",
      "sm2": "",
      "md2": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 300,
      "imaSrc": "design/banco1-1-3",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "Presupuesto mensual ",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v(" Presupuesto "), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" mensual ")])], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Presupuesto mensual',
      "videoEmbed": "ADMINISTRACIONDINERO35PresupuestoMensual.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_2 aligner",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "text-box adorn-bottom"
  }, [_vm._v("Para realizar el "), _c('strong', [_vm._v("presupuesto")]), _vm._v(" se necesita discriminar los\r\n        "), _c('tooltip', {
    staticClass: "tip font-red",
    attrs: {
      "texto": "ingresos",
      "tooltip": "Cantidad de dinero que recibe una persona natural o jurídica por la venta de sus productos o servicios.",
      "textPos": "text-top"
    }
  }), _vm._v(" y\r\n        "), _c('tooltip', {
    staticClass: "tip font-red",
    attrs: {
      "texto": "gastos",
      "tooltip": "Es la cantidad de dinero que debe hacerse cuando se adquiere un producto o servicio.",
      "textPos": "text-top"
    }
  }), _vm._v(" como lo muestran las tablas anteriores. "), _c('br'), _c('br'), _vm._v(" Una vez realizado el presupuesto, es importante hacer un seguimiento de los "), _c('strong', [_vm._v("gastos")]), _vm._v(" en relación con los "), _c('strong', [_vm._v("ingresos")]), _vm._v(", así establecerá un plan para mejorar\r\n        las finanzas personales, optimizando la\r\n        "), _c('strong', [_vm._v("administración")]), _vm._v(" del dinero.\r\n      ")], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner animated fadeIn dura_2",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md6": "",
      "mb-5": "",
      "text-xs-center": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 480,
      "imaSrc": "contenido/diapositiva_36",
      "imaAlt": "Gráfica de un presupuesto por años"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-591597fd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-35.vue
// module id = 1006
// module chunks = 1